import Vue from 'vue'
import Vuex from 'vuex'
import user from './user/index' // 用户
import home from './home/index' // 首页
import saasManage from './saasManage/index' // 菜单管理
import wareManage from './wareManage/index' // 仓库管理
import supplierManage from './supplierManage/index' // 供应商管理
import toggle from './toggle/index' // 侧边栏菜单开关
import dataDictionary from './dataDictionary/index' // 数据字典
import systemConfig from './systemConfig/index' // 系统管理
import goodsManage from './goodsManage/index' // 商品管理
import tenancyManage from './tenancyManage/index' // 租赁管理
import assignmentManage from './assignmentManage/index' // 任务管理
import costConfigure from './costConfigure/index' // 仓库费用管理
import costMenu from './costMenu/index' // 费用报表
import pushMessage from './pushMessage/index' // 消息推送管理
import billManage from './billManage/index' // 账单管理
import dispatchPlatform from './dispatchPlatform/index' // 账单管理
import distriBution from './distriBution/index' // 配送仓点管理
import tagsView from './tagsView'
import officeButtonManage from './officeButtonManage' // 公众号配置菜单管理
import printTemplate from './printTemplate' // 打印模板设置
import merchantManage from './merchantManage/index' // 商户管理
import officialAccountManage from './officialAccountManage/index' // 仓库信息管理
import dataCenter from './dataCenter/index' // 数据中心平台
import liquidationManage from './liquidationManage/index' // 盘点管理
import rollsHomework from './rollsHomework/index' // 库内作业
import warehouseTactics from './warehouseTactics/index' // 仓内管理模式配置
import goodsLocation from './goodsLocation/index' // 货位管理
import inventoryManage from './inventoryManage/index' // 库存总数
import reservoirAreaManage from './reservoirAreaManage/index' // 库区管理
import userData from './userData/index' // 库区管理
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user, // 用户
    home, // 首页
    toggle, // 侧边栏菜单开关
    saasManage, // 菜单管理
    dataDictionary, // 数据字典
    systemConfig, // 系统管理
    goodsManage, // 商品管理
    tenancyManage, // 租赁管理
    wareManage, // 仓库管理
    supplierManage, // 供应商管理
    assignmentManage, // 任务管理
    costConfigure, // 仓库费用管理
    costMenu, // 费用报表
    pushMessage, // 消息推送管理
    userData,
    billManage, // 账单管理
    dispatchPlatform, // 配送平台管理
    distriBution, // 配送仓点管理
    tagsView,
    officeButtonManage, // 公众号配置菜单管理
    printTemplate, // 打印模板设置
    merchantManage, // 商户管理
    officialAccountManage, // 仓库信息管理
    dataCenter,
    liquidationManage, // 盘点管理
    rollsHomework, // 库内作业
    warehouseTactics, // 仓内管理模式配置
    goodsLocation, // 货位管理
    inventoryManage, // 库存总数
    reservoirAreaManage // 库区管理
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js